import { Button } from '@/components/ui/button';
import {} from '@/components/ui/dropdown-menu';
import { useUserInfo } from '@/context/user-info';
import { cn } from '@/lib/utils';
import { ChevronDown } from '@untitled-ui/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  servicesMenuOpen: boolean;
  onMenuOpen: () => void;
  onClickHowItWorks: () => void;
  onClickAboutApp: () => void;
}

export const ServicesSelect = ({
  servicesMenuOpen,
  onMenuOpen,
  onClickHowItWorks,
  onClickAboutApp,
}: Props) => {
  const { t } = useTranslation();
  const { userLanguage } = useUserInfo();

  return (
    <div className={cn({ 'flex flex-col items-center gap-4': true, 'gap-0': !servicesMenuOpen })}>
      <Button
        variant="ghost"
        className="flex items-center gap-1 cursor-pointer"
        onClick={onMenuOpen}
        aria-label={
          servicesMenuOpen
            ? t('translation:accessibility.button.yego_services_close')
            : t('translation:accessibility.button.yego_services_open')
        }
      >
        <p className="text-white text-xl font-black uppercase">
          {t('translation:navbar.link.yego_service')}
        </p>
        <ChevronDown className="size-4 text-white" />
      </Button>

      <div
        className={cn({
          'w-fit z-50 bg-transparent text-white border-none shadow-none flex flex-col items-center gap-3 transition-all duration-150': true,
          'opacity-100': servicesMenuOpen,
          'opacity-0': !servicesMenuOpen,
        })}
      >
        {servicesMenuOpen && (
          <>
            <Link
              to={`/${userLanguage}/how-it-works`}
              className="px-2 font-bold text-base uppercase"
              onClick={onClickHowItWorks}
              aria-label={t('translation:accessibility.button.go_how_it_works')}
            >
              {t('translation:navbar.link.how_it_works')}
            </Link>
            <Link
              to={`/${userLanguage}/about-app`}
              className="px-2 font-bold text-base uppercase"
              onClick={onClickAboutApp}
              aria-label={t('translation:accessibility.button.go_about_app')}
            >
              {t('translation:navbar.link.about_the_app')}
            </Link>
            {userLanguage === 'fr' && (
              <Link
                to="https://greenriders.rideyego.com/engagements-environnementaux"
                className="px-2 font-bold text-base uppercase"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('translation:accessibility.button.go_sustainability')}
              >
                {t('translation:navbar.link.sustainability')}
              </Link>
            )}
          </>
        )}
      </div>
    </div>
  );
};
